import React from 'react';
import { FieldValues } from 'react-hook-form';
//
import { FormInputProps } from '../../componets/form/formInterfaces';
import { ImperativeHandleAccessedByParentComponent } from '../../componets/interfaces/formProps';
import FormComplete from '../../componets/form/formComplete';
import * as ImplEnum from '../../communs/enums/generic-enum';
import { useAuth } from '../../context/AuthContext';
import { useParams } from 'react-router-dom';

const enumInstances = {
    stateOptionsInstance: new ImplEnum.GenericEnum(
        ImplEnum.expertiseSituationOptions,
    ),
};
const expertiseSituationOptions =
    enumInstances.stateOptionsInstance.optionsList();

interface IFormInput extends FieldValues {
    description: string;
}

const Form: React.FC<{ settings: any }> = props => {
    const { settings } = props;
    const params = useParams<'id' | any>();
    const { user } = useAuth();

    const refForm =
        React.useRef<ImperativeHandleAccessedByParentComponent<IFormInput>>(
            null,
        );

    const inputsForm = React.useMemo<FormInputProps<IFormInput>[]>(
        () => [
            {
                typeInput: 'autocomplete',
                name: 'legalProcess',
                control: null,
                label: 'Processo',
                setValue: null,
                md: 4,
                xs: 12,
                rules: {
                    required: true,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo Processo é obrigatório',
                    },
                ],
                query: (value: string) =>
                    `legal-process?legalProcess.processNumber.ilike=${value}`,
                activeDebounce: true,
            },
            {
                typeInput: 'text',
                name: 'details',
                control: null,
                label: 'Detalhes (opcional)',
                loadingAutocomplete: false,
                md: 8,
                xs: 12,
            },
            {
                typeInput: 'text',
                name: 'local',
                control: null,
                label: 'Local',
                loadingAutocomplete: false,
                md: 3,
                xs: 12,
            },
            {
                typeInput: 'autocomplete',
                name: 'user',
                control: null,
                label: 'Advogado',
                setValue: null,
                md: 3,
                xs: 12,
                rules: {
                    required: true,
                },
                messagesError: [
                    {
                        type: 'required',
                        message: 'O campo Advogado(a) é obrigatório',
                    },
                ],
                query: (value: string) => `users?name=${value}`,
                activeDebounce: true,
            },
            {
                typeInput: 'date',
                name: 'dateAudience',
                control: null,
                label: 'Data',
                setValue: null,
                md: 3,
                xs: 12,
                placeholder: 'dd/mm/aaaa hh:mm',
                rules: {
                    validate: (value: any) => {
                        if (value && String(value) === 'Invalid Date') {
                            return 'A data está em um formato inválido';
                        }
                    },
                    required: true,
                },
            },
            {
                typeInput: 'autocomplete',
                name: 'status',
                control: null,
                label: 'Status',
                loadingAutocomplete: false,
                setValue: null,
                options: expertiseSituationOptions,
                md: 3,
                xs: 12,
                rules: {
                    validate: (value: any) => {
                        if (!value?.id) {
                            return 'O campo situação é obrigatório';
                        }
                    },
                },
                dto: data => {
                    data.status = data.status.id;
                    return data;
                },
                setData: data => {
                    return enumInstances.stateOptionsInstance.getObject(
                        data.status,
                    );
                },
            },
            {
                typeInput: 'text',
                multiline: true,
                name: 'observation',
                control: null,
                label: 'Observações',
                loadingAutocomplete: false,
                md: 12,
                xs: 12,
            },
        ],
        [],
    );

    const defaultValues = React.useMemo<any>(() => {
        return {
            user: {
                id: user.sub,
                description: user.name,
            },
            generateInstallments: !params?.id,
        };
    }, [user, params]);

    return (
        <FormComplete
            defaultValues={defaultValues}
            inputsForm={inputsForm}
            ref={refForm}
            settings={settings}
        />
    );
};

export default Form;
